import { run as runActions } from '../../../../../store/workspaces/workspaces/run';


export const handleClick = async (imageID, navData, actionsState) => {
  runActions(navData.widgetData.events.find((event) => event.type === 'onClick').key, imageID, actionsState);
};
